import { PageHeader } from "../../components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import Overview from "./accounting/Overview";
import Ledger from "./accounting/Ledger";
import Accounts from "./accounting/Accounts";
import TaxInvoice from "./accounting/TaxInvoice";
import Budget from "./accounting/Budget";
import Receivables from "./accounting/Receivables";
import BankImport from "./accounting/BankImport";
import { Staff, Recurring } from "./accounting/StaffRecurring";

export default function Accounting() {
  return (
    <div className="space-y-6" data-testid="accounting-page">
      <PageHeader eyebrow="Kasa & Muhasebe" title="Muhasebe" subtitle="Gelir-gider, kasa/banka hesapları, kasa sayımı, personel giderleri, tekrarlayan ödemeler ve kâr analizi." />
      <Tabs defaultValue="overview" urlTab>
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="overview" data-testid="atab-overview">Genel Bakış</TabsTrigger>
          <TabsTrigger value="ledger" data-testid="atab-ledger">Hareketler & Usta Bakiyeleri</TabsTrigger>
          <TabsTrigger value="accounts" data-testid="atab-accounts">Kasa & Hesaplar</TabsTrigger>
          <TabsTrigger value="staff" data-testid="atab-staff">Personel</TabsTrigger>
          <TabsTrigger value="recurring" data-testid="atab-recurring">Tekrarlayan & Kategoriler</TabsTrigger>
          <TabsTrigger value="tax" data-testid="atab-tax">KDV & Fatura</TabsTrigger>
          <TabsTrigger value="budget" data-testid="atab-budget">Bütçe & Hedef</TabsTrigger>
          <TabsTrigger value="receivables" data-testid="atab-receivables">Alacaklar</TabsTrigger>
          <TabsTrigger value="import" data-testid="atab-import">Banka Ekstresi</TabsTrigger>
        </TabsList>
        <TabsContent value="overview" className="mt-4"><Overview /></TabsContent>
        <TabsContent value="ledger" className="mt-4"><Ledger /></TabsContent>
        <TabsContent value="accounts" className="mt-4"><Accounts /></TabsContent>
        <TabsContent value="staff" className="mt-4"><Staff /></TabsContent>
        <TabsContent value="recurring" className="mt-4"><Recurring /></TabsContent>
        <TabsContent value="tax" className="mt-4"><TaxInvoice /></TabsContent>
        <TabsContent value="budget" className="mt-4"><Budget /></TabsContent>
        <TabsContent value="receivables" className="mt-4"><Receivables /></TabsContent>
        <TabsContent value="import" className="mt-4"><BankImport /></TabsContent>
      </Tabs>
    </div>
  );
}
